
import { lazy, Suspense } from "react";
import type { ReactNode } from "react";
import type { RouteObject } from "react-router-dom";

const NotFound = lazy(() => import("../pages/NotFound"));
const Home = lazy(() => import("../pages/home/page"));
const TermsPage = lazy(() => import('../pages/terms/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const RefundPage = lazy(() => import('../pages/refund/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const ResourcesPage = lazy(() => import('../pages/resources/page'));
const HomesPage = lazy(() => import('../pages/homes/page'));
const ListingToolPage = lazy(() => import('../pages/listing-tool/page'));

const routeElement = (element: ReactNode) => (
  <Suspense fallback={<div className="min-h-screen bg-[#f6f0e7]" />}>
    {element}
  </Suspense>
);

const routes: RouteObject[] = [
  {
    path: "/",
    element: routeElement(<Home />),
  },
  {
    path: '/terms',
    element: routeElement(<TermsPage />),
  },
  {
    path: '/privacy',
    element: routeElement(<PrivacyPage />),
  },
  {
    path: '/refund',
    element: routeElement(<RefundPage />),
  },
  {
    path: '/admin',
    element: routeElement(<AdminPage />),
  },
  {
    path: '/resources',
    element: routeElement(<ResourcesPage />),
  },
  {
    path: '/resources/:slug',
    element: routeElement(<ResourcesPage />),
  },
  {
    path: '/homes',
    element: routeElement(<HomesPage />),
  },
  {
    path: '/listing-tool',
    element: routeElement(<ListingToolPage />),
  },
  {
    path: "*",
    element: routeElement(<NotFound />),
  },
];

export default routes;
